/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../behaviors/bills-common-functions.js';
const template = html`
        <style include="app-styles mdl-grid-css bills-shared-styles">
            oe-info {
                    font-size:inherit;
                    --oe-info-value: {
                        font-size: var(--a-font-size-s);
				        color: var(--secondary-dark-color);
                        padding: 0px;
                    };
                    --oe-info-label: {
                         padding: 0px;
                     };
                }
            app-dialog {
                --app-dialog-min-height: 243px
            }

            app-dialog#authorizeelemdia,
            app-dialog#stopbillauthorizeelemdia {
                --app-dialog-min-height: 150px
            }
             .menu-container {
              width: 114px !important;
              padding-left: 22px;
              padding-top: 16px;
              }
			      :dir(rtl) .menu-container {
              width: 114px !important;
              padding-right: 22px;
              padding-top: 16px;
              }

            .menu-height {
             min-height: 127px;
             width: 100%;
            }

            .schedule-menu-container{
            min-width:281px;
        }
            .display-none {
                display: none;
            }

            

            .action-icon-color {
                color: var(--secondary-dark-color);
            }
            /* Added because RWD view of desktop and tablet has an additional container*/
            .padding-dynamic[tablet],
            .padding-dynamic[desktop] {
                padding-left: 0px;
                padding-right: 0px;
            }

            .margin-dynamic[desktop] {
                margin-left: 5px;
                margin-right: 5px;
                width:100%
            }
            .outlineOffset:focus{
              outline:2px solid #0075da;
            }
        </style>
        <app-media-query desktop="{{desktop}}" phone="{{phone}}" tablet="{{tablet}}"></app-media-query>
        <template is="dom-if" if="{{billDetails.billDate}}">
            <div class="mdl-grid padding-zero margin-b-zero  mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">

                 <div id="billCyclePeriod" class="content-align-center"> 
                    <oe-i18n-msg  class="font-weight-bold secondary-dark-text-m" msgid="l_Billed"></oe-i18n-msg><span class="secondary-dark-text-s">:
                    </span>
                    <span  class="content-align-vertical-center"><oe-info id="billDate" type="date" format={{dateFormat}} value="{{billDetails.billDate}}"></oe-info>
                    </span>
                </div>
            </div>
        </template>
                <span style="width:0px !important;height:0px !important" aria-labelledby="hiddenInformation">
                    <div id="hiddenInformation" style="display:none"> <oe-i18n-msg msgid="m_navigationmoreoption"></oe-i18n-msg></div></div>   
                </span>
        <div class="mdl-grid component-outer-container padding-dynamic content-align-center" tablet$="{{tablet}}" desktop$="{{desktop}}">
            
            <paper-card class="light-background bills-shadow border-radius-tl-tr-12px mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop position-relative margin-dynamic"
                tablet$="{{tablet}}" desktop$="{{desktop}}">
                <template is="dom-if" if="{{billDetails}}">
                    <oe-hbox id="billComponentAmount" class="mdl-grid margin-b-zero padding-b-zero font-size-m font-weight-bold mdl-cell mdl-cell--12-col-desktop mdl-cell--4-col-phone">
                    {{symbolizeCurrency(billDetails.billCurrency,billDetails.billAmount)}}
                    </oe-hbox>
                    <oe-hbox class="mdl-grid margin-t-zero padding-t-zero  mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">
                        <!-- <div class=""> -->
                        <template is="dom-if" if="{{_ifBillTypeIsDue(billType)}}">
                                <!-- <div id="billDueOn"> -->
                            <oe-i18n-msg class="secondary-dark-text-s" msgid="l_DueOn"></oe-i18n-msg> :
                            <oe-info  id="billDueOn" type="date" format={{dateFormat}} value="{{billDetails.dueDate}}"></oe-info>
                                <!-- </div> -->
                        </template>
                            <template  is="dom-if" if="{{_ifBillTypeIsScheduled(billType)}}">
                            <oe-i18n-msg  class="secondary-dark-text-s" msgid="l_ScheduledOn"></oe-i18n-msg> 
                             <oe-i18n-msg  class="secondary-dark-text-s" msgid=":"></oe-i18n-msg>
                            <oe-info id="billScheduledOn"  type="date" format={{dateFormat}} value="{{billDetails.scheduledDate}}"></oe-info>
                        </template>
                    </oe-hbox>
                  </template>
                    <br  aria-hidden="true"/>
                    <iron-icon id="MoreMenu" on-tap="_openBillMenu" on-keydown="_openBillDDAMenu" class="outlineOffset more-menu action-icon-color" name="MoreMenu" icon="more-vert" aria-label$="Bills {{getLabel('b_moreActions')}}" tabindex="0" role="button"></iron-icon>
                    <oe-hbox class="mdl-grid">
                    <div id="billReferenceId" class="secondary-dark-text-s margin-8px mdl-cell mdl-cell--3-col-phone mdl-cell--6-col-tablet mdl-cell--9-col-desktop">
                        <oe-i18n-msg   msgid="l_Invoice"></oe-i18n-msg>:{{checkIfTruncate(billDetails.billReferenceNumber)}}
                        </div>
                    <!-- <template is="dom-if" if="{{_ifBillTypeIsDue(billType)}}"> -->
                      <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--2-col-desktop">
                        <div  class="outlineOffset padding-t-zero text-align-right" id="billPayButton" on-tap="billerTransfer" aria-label$="{{getLabel('b_pay')}}" tabindex="0" role="button">
                                <oe-i18n-msg class="font-size-m text-brand-color text-transform-uppercase" msgid="b_Pay"></oe-i18n-msg>
                        </div>
                    </div>
		    <!-- </template> -->
                    <template is="dom-if" if="{{_ifBillTypeIsScheduled(billType)}}">
                        <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col-desktop">
                            <div class="padding-t-zero text-align-right" id="billPayButton">
                                <oe-i18n-msg id="btnStop" tabindex=0 on-tap="_openStopBill" role="button" class="outlineOffset cursor-pointer font-size-m text-brand-color text-transform-uppercase" msgid="b_Stop" aria-label$="{{getLabel('b_Stop')}}" ></oe-i18n-msg>
                            </div>
                        </div>
                    </template>
                    </oe-hbox>
                <div class="zig-zag-bottom-border margin-zero mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop"></div>
            <div id="bill-menu" role="dialog" class="position-absolute-t-r display-none menu-height light-background mdl-grid mdl-grid--no-spacing padding-zero position-relative margin-dynamic">
                        <paper-icon-button id="closeBtn" on-tap="_closeBillMenu" on-keydown="focusMore" class="close-button outlineOffset" icon="close" aria-label$="{{getLabel('b_Close')}}"></paper-icon-button>
                  <div class="mdl-grid mdl-grid--no-spacing margin-l-zero">
                  <!--commented out dummy buttons for defect 374266-->      
                  <!--<paper-button hidden$="{{_ifBillTypeIsScheduled(billType)}}" class="outlineOffset content-align-horizontal-start menu-container font-size-s text-align-left    mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop  ">
                              <oe-i18n-msg class="text-brand-color" msgid="b_AddToCalendar"></oe-i18n-msg>
                        </paper-button>

                        <paper-button hidden$="{{_ifBillTypeIsScheduled(billType)}}" tabindex=0 class="outlineOffset content-align-horizontal-start  menu-container font-size-s  text-align-left     mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop  ">
                            <oe-i18n-msg class="text-brand-color" msgid="b_MarkAsPaid"></oe-i18n-msg>
                        </paper-button>-->
                                        </div>
                                        <div class="mdl-grid mdl-grid--no-spacing  margin-l-zero">
                        <paper-button hidden$="{{_ifBillTypeIsScheduled(billType)}}"  id="autopayBtn" class="outlineOffset content-align-horizontal-start display-block menu-container font-size-s  text-align-left     mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop  "
                                                on-tap="_openAutopay">
                           <oe-i18n-msg class="text-brand-color" msgid="b_AutoPay"></oe-i18n-msg>
                        </paper-button>

                    <paper-button id="CancelautopayBtn" class="font-size-s outlineOffset menu-container text-align-left  mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop">
                                <oe-i18n-msg class="text-brand-color" msgid="b_CancelAutoPay"></oe-i18n-msg>
                     </paper-button>
                     <!--commented out dummy buttons for defect 374266-->
                        <!--<paper-button hidden$="{{_ifBillTypeIsScheduled(billType)}}" class="outlineOffset content-align-horizontal-start  display-block menu-container font-size-s  text-align-left mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop">
                                                <oe-i18n-msg class="text-brand-color" msgid="b_Share"></oe-i18n-msg>
                                            </paper-button>-->

                    <div class="schedule-menu-container text-align-left">
                            <paper-button hidden$="{{!_ifBillTypeIsScheduled(billType)}}" on-tap="_openStopBill" class="outlineOffset content-align-horizontal-start font-size-s menu-container text-align-left  mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop">
                                <oe-i18n-msg class="text-brand-color" msgid="b_Stop" aria-label$="{{getLabel('b_Stop')}}"></oe-i18n-msg>
                            </paper-button>
                    </div>
                      <div class="schedule-menu-container text-align-left">
                            <paper-button hidden$="{{!_ifBillTypeIsScheduled(billType)}}" class="outlineOffset font-size-s content-align-horizontal-start text-align-left menu-container mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet  mdl-cell--6-col-desktop"  
                            on-keydown="closedialog" on-tap="billerTransfer">
                                 <oe-i18n-msg class="text-brand-color" msgid="b_Modify" aria-label$="{{getLabel('b_Modify')}}"></oe-i18n-msg>
                            </paper-button>
                     </div>
                </div>

                                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop zig-zag-bottom-border margin-zero"></div>
                                    </div>
        </paper-card>
        </div>
        <div class="mdl-grid mdl-cell--8-col-tablet mdl-cell--12-col-desktop"></div>
        <template is="dom-if" if="{{billerAutoPayLanding}}">
            <app-dialog name="h_autopay" id="autopayelemdia" elementid="autopayelem" role="dialog">
                <biller-auto-pay-landing auth-methods="{{authMethods}}" header-object="{{headerObject}}" put-biller-object="{{putBillerObject}}"
                    selected-details="{{billerDetails}}" success-message="{{successMessage}}" is-auto-pay-auth-dialog="{{isAutoPayAuthDialog}}"
                    is-auto-pay-success-dialog="{{isAutoPaySuccessDialog}}" registration-id="{{registrationId}}"></biller-auto-pay-landing>
            </app-dialog>
        </template>
        <template is="dom-if" if="{{billerAutoPayAuth}}">    
            <app-dialog name="h_Authorization" id="authorizeelemdia" elementid="authorizeelem" role="dialog">
                <biller-auto-pay-auth auth-methods="{{authMethods}}" header-object="{{headerObject}}" put-biller-object="{{putBillerObject}}"
                    selected-details="{{billerDetails}}" success-message="{{successMessage}}" is-auto-pay-success-dialog="{{isAutoPaySuccessDialog}}" registration-id="{{registrationId}}"></biller-auto-pay-auth>
            </app-dialog>
        </template>
        <template is="dom-if" if="{{billerAutoPaySuccess}}">
            <app-dialog id="successelemdia" elementid="successelem" role="dialog">
                <biller-auto-pay-success id="autopaysuccess" success-message="{{successMessage}}" registration-id="{{registrationId}}" selected-details="{{billerDetails}}"></biller-auto-pay-success>
            </app-dialog>
        </template>
        <template is="dom-if" if="{{stopBill}}">
            <app-dialog name="h_Stop" id="stopbillelemdia" elementid="stopbillelem" role="dialog">
                <stop-bill selected-schedule-bill="{{parsedBill}}" selected-stop-instance-val="{{selectedStopInstanceVal}}" selected-biller="{{billerDetails}}"  payment-instance-detail="{{paymentInstanceDetail}}"
                    auth-methods="{{authMethodsStop}}" header-object="{{headerObject}}" is-stop-auth-dialog="{{isStopAuthDialog}}"></stop-bill>
            </app-dialog>
        </template>           
        <template is="dom-if" if="{{stopBillAuth}}">
            <app-dialog name="h_Authorization" id="stopbillauthorizeelemdia" elementid="stopbillauthorizeelem" role="dialog">
                <stop-bill-auth selected-schedule-bill="{{parsedBill}}" selected-biller="{{billerDetails}}" selected-stop-instance-val="{{selectedStopInstanceVal}}"
                    payment-instance-detail="{{paymentInstanceDetail}}" auth-methods="{{authMethodsStop}}" header-object="{{headerObject}}"></stop-bill-auth>
            </app-dialog>
        </template>`;


Polymer({
    is: "bill-component",
    _template: template,
    behaviors: [sbBehaviours.billCommonFunctions, accessibilityBehaviours.commonFunctions, corpBehaviours.appCommonBehaviour],
    properties: {

        billId: {
            type: String,
            notify: true,
            observer: 'getBillDetails'
        },
        billDetails: {
            type: Object,
            notify: true
        },
        billType: {
            type: String,
            notify: true
        },
        parsedBill: {
            type: Object,
            notify: true
        },
        selectedStopInstanceVal: {
            type: String,
            value: "justone",
            notify: true
        },
        billTypeInfo: {
            type: String,
            notify: true,
            observer: '_billTypeInfo'
        }
    },
    listeners: {
        'iron-overlay-closed': '_openNextDialog'
    },
    ready: function () {
        this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
    },
    // filter and get the entry till first instance of "|"
    // filter and get the entry till first instance of "|"
    filterSubscription: function (input) {
        if (typeof input == 'undefined')
            return;
        if (input.indexOf("|") == '-1')
            return input;
        return input.substr(0, input.indexOf("|"));
    },
    getBillDetails: function () {
        if (!this.billDetails || !this.billDetails.billReferenceNumber) {
            var self = this;
            var ajaxBillDetails = document.createElement('oe-ajax');
            ajaxBillDetails.contentType = "application/json";
            ajaxBillDetails.handleAs = "json";
            if (this.billType === "Due")
                ajaxBillDetails.url = '/api/CBUsers/' + clientStorage.get(storageType.session,
                    'userId') + '/bills/' + this.billId;
            else if (this.billType === "Scheduled")
                ajaxBillDetails.url = '/api/CBUsers/' + clientStorage.get(storageType.session,
                    'userId') + '/billpayments/' + this.billId;
            ajaxBillDetails.method = 'get';
            ajaxBillDetails.addEventListener('response', function (event) {

                self.billDetails = self.createBillDetailsObject(event.detail.response);
            });
            ajaxBillDetails.addEventListener('error', function () {

                self.fire("oe-show-error", {
                    code: 'l_InvalidBillId',
                    message: getLabel('l_InvalidBillId')
                });
            });
            oeAjaxEventListner(ajaxBillDetails);
            ajaxBillDetails.generateRequest();
        }
    },
    dateTransformation: function (billDetails) {
        var dateFrom = getNewDate(billDetails.billedFrom);
        var dateTo = getNewDate(billDetails.billedTo);
        return dateFrom.getDate() + " " + this.monthLocaleTransform(dateFrom) + " " + dateFrom.getFullYear() + "-" + dateTo.getDate() +
            " " + this.monthLocaleTransform(dateTo) + " " + dateTo.getFullYear();
    },
    monthLocaleTransform: function (date) {
        return getNewDate(date).toLocaleString(clientStorage.get(storageType.session, 'lang'), {
            month: "short"
        });
    },
    symbolizeCurrency: function (curr, amount) {
        return currency.symbolize(curr + " " + amount);
    },
    createBillDetailsObject: function (billDetails) {
        var detailsObject;
        if (this.billType === "Due") {
            detailsObject = {
                billCurrency: billDetails.billDetails.amount.currency,
                billAmount: billDetails.billDetails.amount.amount,
                billedFrom: billDetails.billDetails.billedFrom,
                billedTo: billDetails.billDetails.billedTo,
                dueDate: billDetails.billDetails.dueDate,
                billReferenceNumber: billDetails.billDetails.billReferenceNumber,
                billStatus: billDetails.billDetails.status.cmCode,
                billDate: billDetails.billDetails.billDate
            }
        } else if (this.billType === "Scheduled") {
            detailsObject = {
                billCurrency: billDetails.transactionCurrency ? billDetails.transactionCurrency.codeDescription : billDetails.additionalDetails.transactionCurrency.codeDescription,
                billAmount: billDetails.totalTransactionAmount ? billDetails.totalTransactionAmount : billDetails.transactionDetails.transactionAmount,
                billedFrom: billDetails.billedFrom ? billDetails.billedFrom : '',
                billedTo: billDetails.billedTo ? billDetails.billedTo : '',
                scheduledDate: billDetails.transactionDate ? billDetails.transactionDate : billDetails.transactionDetails.transactionDate,
                billReferenceNumber: billDetails.referenceId ? billDetails.referenceId : billDetails.confirmationDetails.requestReferenceId
            }
        }
        return detailsObject;
    },
    _showAutoPayBtn: function () {
        var autopaybtn = this.$$("#autopayBtn");
        var CancelautopayBtn = this.$$("#CancelautopayBtn");
        if (this.billDetails.billStatus === "PEN") {
            autopaybtn.style.display = 'none';
            CancelautopayBtn.style.display = 'block !important';
        } else {
            autopaybtn.style.display = 'block !important';
            CancelautopayBtn.style.display = 'none';
        }
    },
    focusMore: function (e) {
        if (e && e.keyCode === 13) {
            e.stopPropagation(e);
            this._closeBillMenu(e);
        } else if (e.shiftKey && e.keyCode == 9) {
            setTimeout(function () {
                this.$$("#closeBtn").focus();
            }.bind(this));
        }
    },
    closedialog: function (e) {
        if (e.keyCode == 9) {
            setTimeout(function () {
                this.$$("#closeBtn").focus();
            }.bind(this));
        } else if (e.shiftKey && e.key === 'Tab') {
            setTimeout(function () {
                this.$$("#btnStop").focus();
            }.bind(this));
        }
    },
    _closeBillMenu: function () {
        var doc = this.$$("#bill-menu");
        doc.style.display = 'none';
        setTimeout(function () {
            this.$$("#MoreMenu").focus();
        }.bind(this), 500);
    },
    _openBillMenu: function (event) {
        this._showAutoPayBtn(event);
        var doc = this.$$("#bill-menu");
        doc.style.display = 'block';
        event.stopPropagation();
        setTimeout(function () {
            this.$$("#closeBtn").focus();
        }.bind(this), 500);
    },
    _openBillDDAMenu: function (e) {
        if (e && e.keyCode === 13) {
            this._openBillMenu(e);
        }
    },
    _setPagePath: function () {
        window.setParams = {};
        setParams.isRegisteredBiller = "true";
        setParams.billId = this.billId;
        setParams.billType = this.billType;
        setParams.transactDetails = this.transactionHistory;
        setParams.registrationId = this.registrationId;
        setParams.billTypeInfo = this.billTypeInfo;
        setParams.billDetails = this.billDetails;
    },
    billerTransfer: function () {
        if (this.registrationId) {
            this._setPagePath();
            window.oe_navigate_to('/billPayment-new', {
                "isRegisteredBiller": true,
                "billId": this.billId,
                "billType": this.billType,
                "transactDetails": this.transactionHistory,
                "registrationId": this.registrationId,
                "billTypeInfo": this.billTypeInfo,
                "billDetails": this.billDetails
            });
        }
    },
    checkIfTruncate: function (referenceId) {
        if (referenceId.length > 10)
            referenceId = referenceId.substring(0, 10) + "...";
        return referenceId;
    }
});
